function SectionCard({
    title,
    subtitle,
    children,
    rightContent,
    className = "",
    bodyClassName = "",
  }) {
    return (
      <section
        className={`rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200 ${className}`}
      >
        {(title || subtitle || rightContent) && (
          <div className="mb-5 flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
            <div>
              {title && (
                <h3 className="text-lg font-semibold tracking-tight text-slate-900">
                  {title}
                </h3>
              )}
              {subtitle && (
                <p className="mt-1 text-sm text-slate-600">{subtitle}</p>
              )}
            </div>
  
            {rightContent ? <div>{rightContent}</div> : null}
          </div>
        )}
  
        <div className={bodyClassName}>{children}</div>
      </section>
    );
  }
  
  export default SectionCard;